import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';

export const HideLeftButton = ({ handleClick }) => (
	<IconButton color="inherit" edge="start" onClick={handleClick} sx={{ mr: 2 }}>
		<ChevronLeftIcon />
	</IconButton>
);

HideLeftButton.propTypes = {
	handleClick: PropTypes.func,
};
